import React from 'react';
import { motion } from 'framer-motion';
export function SkoolSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-dark relative border-t border-brand-gold/10 overflow-hidden" data-id="element-131">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-132"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-134">
          <h2 className="font-heading font-bold text-3xl md:text-5xl uppercase tracking-tight text-brand-text mb-8" data-id="element-135">
            Todo vive dentro de <span className="text-brand-gold" data-id="element-136">Skool</span>
          </h2>

          <div className="bg-brand-white border border-brand-gold/20 p-6 md:p-8 rounded-2xl shadow-sm mb-6" data-id="element-137">
            <p className="text-lg md:text-xl text-brand-text-muted leading-relaxed mb-5" data-id="element-138">
              Al registrarte, accedes al módulo correspondiente dentro de
              nuestra comunidad privada. Allí encuentras entrenamientos,
              recursos, grabaciones, mentorías, comunidad y el paso a paso para
              avanzar según el nivel que elijas.
            </p>

            <div className="bg-brand-charcoal p-4 rounded-xl border border-brand-gold/10" data-id="element-139">
              <p className="text-brand-gold font-medium" data-id="element-140">
                BUILD, TRACK y SCALE tienen accesos y precios distintos. Cada
                nivel abre recursos específicos para la etapa en la que está tu
                operación.
              </p>
            </div>
          </div>

          <a href="https://www.skool.com/reclutas-digitales-4277" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-5 bg-gradient-to-r from-brand-gold to-brand-gold-bright text-brand-black font-heading font-bold text-lg uppercase tracking-wide rounded-md hover:shadow-[0_0_25px_rgba(232,184,74,0.5)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-141">
            REGISTRARME EN SKOOL
          </a>
        </motion.div>
      </div>
    </section>;
}